import Material from './material';

export default class PBRMaterial extends Material {}
